export default __webpack_public_path__ + "static/media/homebanner.233cbeb1.png";